// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__1tbSH","Button_element":"Button_Button_element__38AXI","LinkMore_item":"Button_LinkMore_item__W6D4p"};